import { all, put, takeLatest } from 'redux-saga/effects';
import constants from '../../../common/constants/CommonConstants';
import { fetchMethodMapping } from '../../../common/constants/EntityActions';
import { NORMAL_USER } from '../../../common/constants/UserManagementConstants';
import { fetchCurrentUser, setMyEntitiesOnly } from '../../routines';

export function* myEntityFilterMgmtSaga({ payload }) {
  try {
    const { level, noFetch } = payload;
    if (!noFetch) {
      yield put(
        fetchMethodMapping[level].trigger({
          usePrevPayload: true,
          forcePage: 1,
        })
      );
    }
  } catch (error) {
    setMyEntitiesOnly.failure({ error });
  }
}
export function* userLoginMyEntityHandler({ payload }) {
  try {
    const { user } = payload;
    const myEntitiesOnly = user.roleName === NORMAL_USER.roleName;
    yield put(
      setMyEntitiesOnly.trigger({
        myEntitiesOnly,
        noFetch: true,
        level: constants.ORGANIZATION_LEVEL,
      })
    );
    yield put(
      setMyEntitiesOnly.trigger({
        myEntitiesOnly,
        noFetch: true,
        level: constants.ACCOUNT_LEVEL,
      })
    );
    yield put(
      setMyEntitiesOnly.trigger({
        myEntitiesOnly,
        noFetch: true,
        level: constants.PIPELINE_LEVEL,
      })
    );
  } catch (error) {
    fetchCurrentUser.failure({ error });
  }
}

export default function* root() {
  yield all([
    takeLatest(setMyEntitiesOnly.TRIGGER, myEntityFilterMgmtSaga),
    takeLatest(fetchCurrentUser.SUCCESS, userLoginMyEntityHandler),
  ]);
}
